<ng-container [formGroup]="form">
  <div [ngClass]="{'is-focused': $any(password).isFocused, 'has-error': form.errors?.password }"
       class="form-group label-static is-empty">
    <label class="control-label">
      <span>{{ 'profile-form.new_password' | translate }}</span>
      <span class="required">*</span>
    </label>
    <input class="form-control"
           formControlName="password"
           type="password"
           #password
           appFocusable
           (onFocusChange)="$any(password).isFocused = $event">
    @if (form.errors?.password) {
      <app-input-errors [errorsForField]="form.errors?.password"
                        [translationKey]="'errors.profile-form.new_password'"/>
    }
  </div>
  <div [ngClass]="{'is-focused': $any(confirm).isFocused, 'has-error': form.errors?.password_confirmation  }"
       class="form-group label-static is-empty">
    <label class="control-label">
      <span>{{ 'profile-form.confirm_new_password' | translate }}</span>
      <span class="required">*</span>
    </label>
    <input class="form-control"
           formControlName="password_confirmation"
           type="password"
           #confirm
           appFocusable
           (onFocusChange)="$any(confirm).isFocused = $event"
           id="input">
    @if (form.errors?.password_confirmation) {
      <app-input-errors [errorsForField]="form.errors?.password_confirmation"
                        [translationKey]="'errors.profile-form.confirm_new_password'"/>
    }
  </div>
</ng-container>
